import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { BRAND, WHATSAPP_LINK } from "../brand";

const nav = [
  { to: "/", label: "Home", testId: "nav-home-link" },
  { to: "/services", label: "Services", testId: "nav-services-link" },
  { to: "/plans", label: "Subscription", testId: "nav-plans-link" },
  { to: "/blog", label: "Blog", testId: "nav-blog-link" },
  { to: "/about", label: "About", testId: "nav-about-link" },
  { to: "/contact", label: "Contact", testId: "nav-contact-link" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#f7f5f2]/80 border-b border-[#e5e2dc]/70"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo-link"
          className="font-display text-3xl md:text-4xl font-black tracking-tighter lowercase text-[#0a0a0a] leading-none"
        >
          {BRAND.name}
          <span className="ml-1 inline-block w-2 h-2 rounded-full bg-[#c45b3e] align-top mt-2" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={n.testId}
              className={({ isActive }) =>
                `text-sm font-bold tracking-wide link-underline ${
                  isActive ? "text-[#0a0a0a]" : "text-[#5c5a56] hover:text-[#0a0a0a]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-btn"
            className="btn-whatsapp text-sm !py-3 !px-5"
          >
            <MessageCircle size={16} strokeWidth={2.5} />
            Book on WhatsApp
          </a>
        </div>

        <button
          type="button"
          aria-label="Open menu"
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 rounded-full border border-[#e5e2dc]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[#e5e2dc] bg-[#f7f5f2] px-6 py-6 space-y-4"
        >
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`${n.testId}-mobile`}
              className="block text-lg font-bold text-[#0a0a0a]"
            >
              {n.label}
            </NavLink>
          ))}
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-btn-mobile"
            className="btn-whatsapp w-full justify-center mt-2"
          >
            <MessageCircle size={18} strokeWidth={2.5} /> Book on WhatsApp
          </a>
        </div>
      )}
    </header>
  );
};
